import { StarRating } from 'components/Blocks/Reviews/StarRating';
import React, { useMemo } from 'react';
import { RatingBreakdown } from 'types/review';

type ProductRatingBreakdownProps = {
    breakdowns: RatingBreakdown[];
    min?: number;
    max?: number;
    step?: number;
};

export const ProductRatingBreakdown = ({ breakdowns, min = 0, max = 5, step = 1 }: ProductRatingBreakdownProps) => {
    const generateRatings = (min: number, max: number, step: number) => {
        const ratings = [];
        for (let i = min; i <= max; i += step) {
            ratings.push(i);
        }

        return ratings;
    };

    const ratings = useMemo(() => generateRatings(min, max, step), [min, max, step]);

    const countsOfRatingsInBreakdown = useMemo(() => {
        return ratings
            .map((rating, index) => {
                const lowerBound = index === 0 ? min - step : ratings[index - 1];
                const upperBound = index === ratings.length - 1 ? max + step : ratings[index + 1];

                const breakdownsInBoundaries = breakdowns.filter((b) => b.rating > lowerBound && b.rating < upperBound);
                const countOfRatingsInBreakdown = breakdownsInBoundaries.reduce((c, { count }) => c + count, 0);

                return { rating, count: countOfRatingsInBreakdown };
            })
            .sort((a, b) => b.rating - a.rating);
    }, [breakdowns, ratings, min, max, step]);

    return (
        <div>
            {countsOfRatingsInBreakdown.map((breakdown, index) => (
                <div key={`rating-${index}`} className="flex flex-row items-center">
                    <span className="text-small text-grayDark">{breakdown.rating}</span>&nbsp;
                    <StarRating rating={breakdown.rating} type="small" />
                    &nbsp;
                    <span className="text-small text-grayDark">{breakdown.count}&nbsp;x</span>
                </div>
            ))}
        </div>
    );
};
